import { VideoType, AvatarType, RecurringMeeting } from 'Shared/constants/types';

export enum OnboardingFlowType {
  mobile = 'mobile',
  mobileCalendarIntegration = 'mobile_calendar_integration',
  calendarIntegration = 'calendar_integration',
  agendaAi = 'agenda_ai',
  magicOneOnOne = 'magic_one_on_one',
  magicOneOnOneInvited = 'magic_one_on_one_invited',
  calendarIntegration2023 = 'calendar_integration_2023',
  calendarIntegration2023Invited = 'calendar_integration_2023_invited',
}

export enum OnboardingWizardStep {
  profile = 'profile',
  workspaces = 'workspaces',
  discussionTopics = 'discussion_topics',
  discussionTopicsForInvited = 'discussion_topics_for_invited',
  kudos = 'kudos',
  managerAssistantSettings = 'manager_assistant_settings',
  createAccount = 'create_account',
  terminal = 'terminal',
  connectCalendar = 'connect_calendar',
  workspacesFromCalendar = 'workspaces_from_calendar',
  oneOnOneWorkspacesFromCalendar = 'one_on_one_workspaces_from_calendar',
  groupWorkspacesFromCalendar = 'group_workspaces_from_calendar',
  inviteTeammates = 'invite_teammates',
  zoomProfileAndWorkspaces = 'zoom_profile_and_workspaces',
  zoomProfile = 'zoom_profile',
  zoomCreateAccount = 'zoom_create_account',
  magicOneOnOneCreateAccount = 'magic_one_on_one_create_account',
  scheduleDemo = 'schedule_demo',
  connectSlack = 'connect_slack',
  nextMeeting = 'next_meeting',
  generateAgenda = 'generate_agenda',
  letsGo = 'lets_go',
  generateAgendaManual = 'generate_agenda_manual',
  calendarIntegration2023CreateAccount = 'calendar_integration_2023_create_account',
  calendarIntegration2023IntroSlides = 'calendar_integration_2023_intro_slides',
}

export type WorkspacesType = Array<{
  fullName?: string;
  avatar?: AvatarType;
  uuid: string;
  recurring_meeting_uuid?: string;
  personalMessage?: string;
  name?: string;
}>;

export type KudosType = {
  workspaceUuid: string;
  likeThatText: string;
  likeThatVideo: VideoType;
  gifUrl: string;
};

export type OnboardingState = {
  step: OnboardingWizardStep;
  profile: {
    usingWP: Array<string>;
    role: string;
    fullName: string;
    avatar: AvatarType;
    email: string;
    teammateName?: string;
  };
  workspaces: WorkspacesType;
  discussionTopics: Array<string>;
  stepIndex: number;
  kudos?: KudosType;
  invitationInformation: InvitationInfoType;
  managerAssistantSettings: {
    recurrenceAmount: number;
    recurrenceInterval: string;
  };
  numDirectReports: number;
  userCreatedInMiddle: boolean;
  flowType: string;
  forceToDesktop: boolean;
  recurringMeetings: Array<RecurringMeeting>;
  cannotSignIntoGoogle: boolean;
  showInAppBrowserScreen: boolean;
  uuid: string;
};

export type InvitationInfoType = {
  invited_by_full_name: string;
  invited_by_avatar: AvatarType;
  workspace_name: string;
  workspace_uuid: string;
  discussion_topics: Array<string>;
  workspace_is_group: boolean;
};
